import React from "react";
import { useTranslation } from "react-i18next";
import { Typography, CardContent, Box } from "@mui/material";
import { RISK_MESSAGE_COLOR_MAP } from "../../constants";
import { getRiskMessageLabel, getRiskNameLabel } from "../../helpers";
import RiskDescriptionContent from "../../shared/riskDescription/RiskDescriptionContent";
import SegmentedRiskGauge from "../../shared/SegmentedRiskGauge/SegmentedRiskGauge";

const DEFAULT_RISK_COLOR = "#9E9E9E";

const RiskItem = ({
  name,
  risk,
  message,
  description = "",
  descriptionDict,
  riskType,
}) => {
  const { t } = useTranslation();

  const color =
    (message != null && RISK_MESSAGE_COLOR_MAP[message]) || DEFAULT_RISK_COLOR;
  const normalizedRiskType = (riskType || name || "").toLowerCase();

  return (
    <div>
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 0,
        }}
      >
        <Box display="flex" alignItems="center" gap={2} textAlign="center">
          <SegmentedRiskGauge
            risk={risk}
            message={message}
            binCount={descriptionDict?.bin_count}
            size={100}
            thickness={8}
            labelVariant="h6"
          />

          <Box>
            <Typography variant="h6">
              {getRiskNameLabel(name, t) ?? "—"}
            </Typography>

            <Typography
              variant="body1"
              style={{ color }}
              fontWeight={600}
              marginTop={1}
            >
              {getRiskMessageLabel(message, t) ?? "—"}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ marginTop: "15px", width: "100%" }}>
          <RiskDescriptionContent
            riskType={normalizedRiskType}
            description={description}
            descriptionDict={descriptionDict}
            risk={risk}
            dense
          />
        </Box>
      </CardContent>
    </div>
  );
};

export default RiskItem;
